export default __webpack_public_path__ + "static/media/764.71f7c793.gif";